const SUPPORTED_TYPES = new Set([
  'single_choice',
  'multi_select',
  'short_text',
  'long_text',
  'numeric',
  'boolean',
  'code',
]);

const normalizeType = (value) => {
  const raw = String(value || '')
    .trim()
    .toLowerCase();

  if (SUPPORTED_TYPES.has(raw)) return raw;
  if (raw === 'mcq' || raw === 'radio') return 'single_choice';
  if (raw === 'checkbox' || raw === 'set') return 'multi_select';
  if (raw === 'number') return 'numeric';
  if (raw === 'textarea') return 'long_text';
  if (raw === 'text') return 'short_text';
  return 'short_text';
};

export function normalizeStudentExamPayload(payload) {
  const root = payload && typeof payload === 'object' ? payload : {};
  const studentView =
    root.studentView && typeof root.studentView === 'object' ? root.studentView : root;
  const rawQuestions = Array.isArray(studentView.questions) ? studentView.questions : [];

  const questions = rawQuestions.map((question, index) => ({
    id: String(question?.id || question?.questionId || `q_${index + 1}`),
    type: normalizeType(question?.type),
    prompt: String(question?.prompt || question?.question || ''),
    points: Number(question?.points || 1) || 1,
    required: Boolean(question?.required ?? true),
    difficulty: String(question?.difficulty || 'medium'),
    options: Array.isArray(question?.options)
      ? question.options.map((option) => String(option))
      : [],
    ui: question?.ui && typeof question.ui === 'object' ? question.ui : {},
    metadata: question?.metadata && typeof question.metadata === 'object' ? question.metadata : {},
  }));

  return {
    sessionId: String(root.sessionId || ''),
    examId: String(studentView.examId || root.examId || ''),
    title: String(studentView.title || root.title || 'Exam'),
    instructions: String(studentView.instructions || root.instructions || ''),
    totalPoints:
      Number(studentView.totalPoints || root.totalPoints) ||
      questions.reduce((sum, question) => sum + question.points, 0),
    questions,
  };
}

export function toLegacyQuestionShape(question, index) {
  const type = normalizeType(question?.type);
  return {
    question_id: String(question?.id || `q_${index + 1}`),
    question_text: String(question?.prompt || ''),
    question_type: type,
    field_type:
      type === 'single_choice'
        ? 'radio'
        : type === 'multi_select'
          ? 'checkbox'
          : type === 'long_text' || type === 'code'
            ? 'textarea'
            : type === 'numeric'
              ? 'number'
              : 'text',
    points: Number(question?.points || 1) || 1,
    difficulty_level: String(question?.difficulty || 'medium'),
    required: Boolean(question?.required ?? true),
    options: Array.isArray(question?.options) ? question.options : [],
    ui: question?.ui && typeof question.ui === 'object' ? question.ui : {},
    metadata: question?.metadata && typeof question.metadata === 'object' ? question.metadata : {},
  };
}
